module.exports = __webpack_public_path__ + "img/fc821c1.png";